var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shop-modal" }, [
    _c(
      "button",
      {
        class: _vm.triggerButtonClassList,
        attrs: { type: "button", disabled: _vm.disabled },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.showModal()
          },
        },
      },
      [_vm._t("trigger")],
      2
    ),
    _vm._v(" "),
    _vm.isModalVisible
      ? _c("div", { staticClass: "modal" }, [
          _c("div", {
            staticClass: "modal__background",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.closeModal()
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "modal__overlay" }, [
            _c(
              "button",
              {
                staticClass: "button modal__overlayClose",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.closeModal(true)
                  },
                },
              },
              [_c("Cross")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal__content" },
              [_vm._t("content")],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }